import { useState, useEffect } from 'react';

/**
 * CSS 미디어 쿼리를 자바스크립트에서 그대로 쓴다.
 *
 * 화면 폭에 따라 스타일이 아니라 '동작'이 달라져야 할 때 쓴다.
 * (예: 모바일에서는 같은 버튼이 드롭다운 대신 사이드바를 연다)
 *
 * @param {string} query 예: '(max-width: 768px)'
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => (typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false),
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);

    setMatches(mql.matches);   // 구독 사이에 폭이 바뀌었을 수 있다
    // Safari 14 이하는 addEventListener를 지원하지 않는다
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}
